import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface IPaginationFooterProps {
  standalone?: boolean;
  nested?: boolean;
}

const PaginationFooter = styled.footer<IPaginationFooterProps>`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;

  @media (min-width: ${theme.breakpoint.small}px) {
    flex-flow: row nowrap;
    justify-content: flex-end;
    height: ${toRem(66)};
  }

  ${({ nested }) =>
    nested &&
    css`
      padding: 0 ${toRem(theme.space.xl)};
      border-top: ${toRem(1)} solid ${theme.color.neutral[200]};
    `}

  ${({ standalone }) =>
    standalone &&
    css`
      padding: 0 ${toRem(theme.space.xl)};

      @media (min-width: ${theme.breakpoint.small}px) {
        padding: 0 ${toRem(theme.space['3xl'])};
      }
    `}
`;

export default PaginationFooter;
